import type { Control } from 'react-hook-form';
import type { IntlShape } from 'react-intl';

import { ControlSize } from '#components/form/ControlSize.ts';
import { ControlledFormInput } from '#components/form/FormInput.tsx';
import type { OrderFormCollection } from '#features/orderForm/model/OrderFormCollection.ts';

import type { OrderFormData } from '../model/OrderFormValidation.ts';

export const CustomerInput = ({
    intl,
    control,
    namePrefix,
}: {
    intl: IntlShape;
    control: Control<OrderFormData> | Control<OrderFormCollection>;
    namePrefix?: string;
}) => {
    const name = namePrefix ? `${namePrefix}.customerName` : 'customerName';
    return (
        <ControlledFormInput
            label={intl.formatMessage({
                id: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.step1.customer',
            })}
            name={name}
            iconName={'user'}
            control={control}
            size={ControlSize.LARGE}
        />
    );
};
